import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { MatNativeDateModule } from '@angular/material/core';
import { TimeagoModule } from 'ngx-timeago';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AuthInterceptor } from './app/services/auth.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';


bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule,  FontAwesomeModule, TimeagoModule.forRoot(), MatNativeDateModule, MatDialogModule, MatSnackBarModule, MatTooltipModule),

      //importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatInputModule, MatChipsModule, MatDialogModule, MatTabsModule, MatMenuModule, MatListModule, MatRadioModule, MatCheckboxModule, MatSliderModule, MatSlideToggleModule, MatTooltipModule, MatSnackBarModule, MatExpansionModule, MatAutocompleteModule, MatPaginatorModule, MatSelectModule, MatStepperModule, MatDatepickerModule, MatBadgeModule, MatSidenavModule, ClipboardModule, DragDropModule, FontAwesomeModule, NgxResizeObserverModule, TimeagoModule.forRoot(), MatNativeDateModule),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
